<template>
  <b-container class="bv-example-row" fluid>
    <b-row align-h="end">
      <b-button variant="success" @click="openFieldModal">
        เพิ่มข้อมูล
      </b-button>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="items"
      >
        <!-- 
        <template slot="created_at" slot-scope="data">
          <div class="col-center">
            {{ data.item.created_at }}
          </div>
        </template> -->

        <template slot="action" slot-scope="data">
          <b-container fluid>
            <b-row>
              <b-col>
                <b-button
                  variant="warning"
                  @click="openFieldModal(data.item.id)"
                >
                  แก้ไข
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="danger"
                  @click="openDeleteModal(data.item.id)"
                >
                  ลบ
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
    </b-row>
    <sweet-modal ref="inputModal">
      <input-modal :fields.sync="inputFields" />
      <b-row>
        <b-col cols="auto">
          <b-button variant="success" @click="submit">
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button @click="$refs['inputModal'].close()">
            ยกเลิก
          </b-button>
        </b-col>
      </b-row>
    </sweet-modal>
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delUnit"
    >
      <confirm-modal />
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import InputModal from "../../components/Settings/InputModal";
import ConfirmModal from "../../components/Settings/ConfirmModal";

export default {
  name: "Unit",
  components: {
    InputModal,
    ConfirmModal,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
          isInputField: false,
        },
        {
          key: "name",
          label: "NAME",
          isInputField: true,
          isSpecialField: false,
          fieldType: "text",
        },
        {
          key: "description",
          label: "DESCRIPTION",
          isInputField: true,
          isSpecialField: true,
          fieldType: "selected",
          resources: [],
        },
        {
          key: "created_at",
          label: "DATE CREATED",
          isInputField: false,
        },
        {
          key: "action",
          label: "ACTIONS",
          isInputField: false,
        },
      ],
      inputFields: [
        {
          key: "name",
          label: "Name",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
        {
          key: "description",
          label: "Description",
          fieldType: "text",
          rvalue: "",
          required: false,
          default: "",
        },
      ],
      items: [],
      itemSelected: null,
      modalTitle: "",
      deleteUnitIdSelected: null,
      password: "",
    };
  },
  methods: {
    ...mapActions({
      getUnits: "Settings/getUnits",
      createUnit: "Settings/createUnit",
      updateUnit: "Settings/updateUnit",
      deleteUnit: "Settings/deleteUnit",
    }),
    async openFieldModal(unitId = null) {
      this.itemSelected =
        this.items.find((item) => {
          return item.id === unitId;
        }) || null;

      this.clearInputField();

      this.$refs["inputModal"].open();
    },
    async openDeleteModal(unitId) {
      this.deleteUnitIdSelected = unitId;
      // this.$refs['confirmDelete'].show();
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.password = password;
        this.delUnit();
      } else {
        this.password = "";
        return;
      }
    },
    async submit() {
      let payload = {};
      let malformedCheck = false;
      this.inputFields.forEach((el) => {
        if (el.value === null || el.value === "" || el.value === undefined) {
          if (!el.required) {
            payload[el.key] = el.default;
          } else {
            malformedCheck = true;
            this.$swal.fire("กรอกข้อมูลไม่ครบ");
          }
        } else {
          payload[el.key] = el.value;
        }
      });

      if (malformedCheck) {
        return;
      }
      this.$refs["inputModal"].close();

      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.password = password;
      } else {
        this.password = "";
        this.$refs["inputModal"].open();
        return;
      }

      this.$store.state.isLoading = true;
      if (this.itemSelected) {
        try {
          var res = await this.updateUnit({
            payload,
            id: this.itemSelected.id,
            password: this.password,
          });
        } catch (e) {
          this.password = "";
          this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
          this.$store.state.isLoading = false;
          return;
        }
      } else {
        try {
          var res = await this.createUnit({
            payload,
            password: this.password,
          });
        } catch (e) {
          this.password = "";
          this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
          this.$store.state.isLoading = false;
          return;
        }
      }

      try {
        this.items = await this.getUnits();
      } catch (e) {
        this.password = "";
        this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        this.$store.state.isLoading = false;
        return;
      }
      this.$refs["inputModal"].close();
      this.itemSelected = null;
      this.password = "";
      await this.$swal.fire("บันทึกเสร็จสิ้น");
      this.$store.state.isLoading = false;
    },
    clearInputField() {
      if (this.itemSelected) {
        this.inputFields.forEach((el) => {
          el.value = this.itemSelected[el.key];
        });
      } else {
        this.inputFields.forEach((el) => {
          el.value = "";
        });
      }
      this.modalTitle = this.itemSelected ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล";
    },
    async delUnit() {
      this.$store.state.isLoading = true;
      try {
        let res = await this.deleteUnit({
          id: this.deleteUnitIdSelected,
          password: this.password,
        });
      } catch (e) {
        this.password = "";
        this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        this.$store.state.isLoading = false;
        return;
      }

      try {
        this.items = await this.getUnits();
      } catch (e) {
        this.password = "";
        this.$swal.fire("เกิดข้อผิดพลาด", e.message, "error");
        this.$store.state.isLoading = false;
        return;
      }
      this.deleteSpeciesIdSelected = null;
      await this.$swal.fire("ลบข้อมูลเสร็จสิ้น");
      this.$store.state.isLoading = false;
      // this.$refs['confirmDelete'].hide();
    },
  },
  async mounted() {
    this.items = await this.getUnits();
  },
};
</script>

<style scoped></style>
